export const styles = {
  heading: { ml: { lg: 8, xs: 2 }, mt: { lg: 5, xs: 4 } },
  description: { 
    ml: { lg: 8, xs: 2 },
    mt: { lg: 8, xs: 4 }, 
    fontSize: {
      xs: "18px",
      md: "22px",
    },
 },
  divider: { border: "1px solid grey", height: "600px", width: "1px" },
  containerBox: {
    minHeight: "100vh",
  },
  gridPadding: {
    p: {
      xs: 2,
    },
  },
  dividerWrapper: {
    pb: 15,
  },
  learnerTitle: {
    mt: 10,
  },
  learnerStepTitle: {
    mt: 10,
  },
  arrowBoxLarge: {
    justifyContent: "center",
    display: "flex",
    mt: 8,
    mb: 5,
  },
  arrowBox: {
    justifyContent: "center",
    display: "flex",
    mt: 5,
    mb: 5,
  },
  learnerFaqButtonBox: {
    mt: 6,
    mb: 9,
    justifyContent: "center",
    display: "flex",
  },
  educatorFaqButtonBox: {
    mt: 12,
    mb: 10,
    justifyContent: "center",
    display: "flex",
  }
};
